<template>
  <div class="index-page">
    <div class="app-down flex-between">
      <div class="flex-center">
        <img src="../../static/images/logo_download.svg" alt />
        <div class="download-content">
          <p>SuperEx APP</p>
          <span class="block">{{$t('300261')}}</span>
        </div>
      </div>
      <div class="flex-center">
         <dl @click="$router.push({path:'/download',query:{type:'index'}})">
          <dt>
             <svg>
          <use xlink:href='#icon-xiazaitubiao1'></use>
         </svg>
          </dt>
          <dd>{{$t('300345')}}</dd>
        </dl>
        <!-- <span class="inline-block download-icon" @click="$router.push('/download')">
          <i class="iconfont icon-chongbi"></i>
        </span> -->
        <!-- <i class="iconfont icon-guanbi1 download-close-icon" @click="appDownShow = false"></i> -->
      </div>
    </div>
    <headerTop />
    <div class="index-main">
      <van-notice-bar :scrollable="false">
        <div slot="left-icon" class="left-icon">
          <svg
            slot="image"
            class="icon"
            :class="isDirection ? 'mirrorRotateLevel' : ''"
            aria-hidden="true"
          >
            <use xlink:href="#icon-a-Frame22" />
          </svg>
        </div>
        <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
          <van-swipe-item
            v-for="item in noticeList"
            :key="item.id"
            @click="handleLink(item.html_url)"
          >{{item.title}}</van-swipe-item>
        </van-swipe>
        <div slot="right-icon" class="right-icon">
          <a
            :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410470420249' : language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410470420249' : 'https://support.superex.com/hc/en-001/categories/4410470420249'"
          >{{$t('300281')}}</a>
        </div>
      </van-notice-bar>
      <div class="banner-container">
        <van-swipe :autoplay="3000" indicator-color="#FFC72B">
          <van-swipe-item @click="goUrl(item)" v-for="(item, index) in bannerList" :key="index">
            <img :src="item.image" alt />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="market-table">
        <div class="thead flex-between">
          <span class="th inline-block">{{$t('300233')}}</span>
          <span class="th inline-block">{{$t('300234')}}</span>
          <span class="th inline-block">{{$t('300235')}}</span>
        </div>
        <div class="tr flex-between" v-for="(item,index) in marketList" :key="item.symbol">
          <div class="td inline-block flex-center">
            <img :src="marketConfig[item.symbol].imgs" alt />
            <p>
              <span class="block coin-name uppercase">{{item.symbol.split('_')[0]}}</span>
              <span class="block englishName capitalize">{{marketConfig[item.symbol].englishName}}</span>
            </p>
          </div>
          <div
            class="td inline-block"
          >{{ item.state == 3 ? '--' : '$'+toThousands(item.recentQuotation) }}</div>
          <div class="td right inline-block flex-center">
            <span
              class="inline-block"
              :class="item.change >= 0 ? 'buyColor' : 'sellColor'"
            >{{item.state == 3 ? '--' : item.change+'%'}}</span>
            <svg
              v-show="item.change >= 0 && item.state != 3"
              slot="image"
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-lvzhang" />
            </svg>
            <svg
              v-show="item.change < 0 && item.state != 3"
              slot="image"
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-hongdie" />
            </svg>
          </div>
        </div>
        <p class="more" @click="$router.push('/register')">
          {{$t('300089')}}&nbsp;&nbsp;
          <i
            class="iconfont icon-gengduo inline-block"
            :class="isDirection ? 'mirrorRotateLevel' : ''"
          ></i>
        </p>
      </div>
      <div class="activity-center" @click="$router.push({path: '/activity', query:{ language: $route.query.language }})">
      <div class="activity-left">
      <div class="activity-title">
        <span class="bold">{{ $t('300358') }}</span>
          <span>HOT</span>
      </div>
      <div>
        <van-swipe vertical class="activity-notice" :autoplay="1500" :show-indicators="false">
          <van-swipe-item v-for="(items,index) in joinUserList" :key="index">
            <img
              :class="{mirrorRotateLevel:isDirection}"
              src="../../static/images/coin.png"
              alt
            />
            <p v-if="items.type === 1"><span>{{items.notice}}</span></p>
            <p v-if="items.type === 2" class="winnerMsg"><span class="content">{{$t('300357',{user:items.awardeeName,shop:items.awardGoods})}}</span></p>
          </van-swipe-item>
        </van-swipe>
      </div>
      </div>
        <div class="activity-right">
         <img src="../../static/images/activity_gift.png" alt="">
        </div>
      </div>
      <div class="novice-guidance">
        <h1 class="title-content">{{$t('300236')}}</h1>
        <p>{{$t('300237')}}</p>
        <div class="novice-guidance-content">
          <div class="flex-center">
            <div
              class="first-title pointer inline-block"
              :class="{active:activeIndexCopy == i}"
              v-for="(item,i) in titleList"
              :key="i+'e'"
              @click="activeIndexCopy = i"
            >{{ item }}</div>
          </div>
          <div class="flex-between">
            <div class="pointer article-item" v-for="(item,i) in list" :key="i+'f'">
              <a
                @click="goLink(item.link)"
                class="block"
                target="_blank"
                :class="{'pointer':item.link}"
                :style="{backgroundImage:'url(' + item.imgUrl + ')'}"
              ></a>
              <span class="second-title block">{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="global-trade">
        <h1 class="title-content">{{$t('300238')}}</h1>
        <p>{{$t('300239')}}</p>
        <div class="flex items">
          <img src="../../static/images/icon1.svg" alt />
          <div class="item-content">
            <p>{{$t('300240')}}</p>
            <span class="block">{{$t('300241')}}</span>
          </div>
        </div>
        <div class="flex-center items">
          <img src="../../static/images/icon2.svg" alt />
          <div class="item-content">
            <p>{{$t('300242')}} (Q2)</p>
            <span class="block">{{$t('300243')}}</span>
          </div>
        </div>
        <div class="flex-center items">
          <img src="../../static/images/icon3.svg" alt />
          <div class="item-content">
            <p>{{$t('300244')}} (Q2)</p>
            <span class="block">{{$t('300245')}}</span>
          </div>
        </div>
        <div class="flex-center items">
          <img src="../../static/images/icon4.svg" alt />
          <div class="item-content">
            <p>{{$t('300246')}}</p>
            <span class="block">{{$t('300247')}}</span>
          </div>
        </div>
      </div>
      <div class="download-app">
        <h1 class="title-content">{{$t('300248')}}</h1>
        <p>{{$t('300249')}}</p>
        <img src="../../static/images/mobileModel.png" alt />
        <div class="flex-between">
          <div class="qrcode-box">
            <div id="qrcode"></div>
            <p v-html="$t('300253')"></p>
          </div>
          <div class="link-box">
            <div class="flex-between">
              <div class="flex" @click="goLink(downloadUrl.appStore)">
                <i class="iconfont icon-ios1"></i>
                <span class="block">App Store</span>
              </div>
              <div class="flex" @click="goLink(downloadUrl.TFLink)">
                <i class="iconfont icon-ios1"></i>
                <span class="block">TestFlight</span>
              </div>
            </div>
            <div class="flex-between">
              <div class="flex" @click="goLink(downloadUrl.googlePlay)">
                <i class="iconfont icon-guge2"></i>
                <span class="block">Google Play</span>
              </div>
              <div class="flex" @click="goLink(downloadUrl.androidApk)">
                <i class="iconfont icon-anzhuo3"></i>
                <span class="block">Android APK</span>
              </div>
            </div>
          </div>
        </div>
        <p class="more" @click="$router.push('/downloadMore')">
          {{$t('300250')}}&nbsp;&nbsp;
          <i
            class="iconfont icon-gengduo inline-block"
            :class="isDirection ? 'mirrorRotateLevel' : ''"
          ></i>
        </p>
      </div>
      <div class="register-box">
        <h1>{{$t('300251')}}</h1>
        <!-- 登录/注册 -->
        <span class="inline-block" @click="$router.push('/login')">{{$t("300317")}}</span>
      </div>
    </div>
    <footerView />
  </div>
</template>

<script>
import headerTop from "../compontents/headerTop";
import { NoticeBar, Swipe, SwipeItem } from "vant";
import pako from "pako";
import { getNotice, getBanner, getList, versionsApi } from "@/api/resource";
import { getDomains } from "../api/user";
import { toThousands, toNonExponential, parseTime } from "../utils";
import * as configs from '../../config/config'
import { mapGetters } from "vuex";
import QRcode from "qrcodejs2";
import footerView from "../compontents/footerView";
import { languageArr, languageName } from '@/utils/utilsType'
import { setCookie,getCookie } from '@/utils/auth'
import {getActivityLoop} from "./activityCenter/activity";

export default {
  name: "index",
  components: {
    headerTop,
    vanNoticeBar: NoticeBar,
    vanSwipe: Swipe,
    vanSwipeItem: SwipeItem,
    footerView
  },
  data() {
    return {
      appDownShow: true,
      noticeList: [],
      bannerList: [],
      marketList: null,
      websocke: null,
      pongTime: null,
      heartCheck: {},
      marketConfig: {},
      rateConfig: {},
      socketStatus: true,
      titleList: [],
      activeTitle: 0,
      account: "",
      activeIndexCopy: 0,
      articleList: [],
      domain: '',
      joinUserList: [],
      downloadUrl: {
        appStore: "",
        googlePlay: "",
        androidApk: "",
        TFLink: ""
      },
    }
  },
  computed: {
    ...mapGetters(['isDirection', 'language']),
    list() {
      var arr = [];
      this.articleList.forEach(v => {
        if (v.sort == this.activeIndexCopy) {
          if (v.list.length > 3) {
            arr = v.list.slice(0, 3);
          } else {
            arr = v.list;
          }
        }
      });
      return arr;
    }
  },
  created() {
    this.change_language()
    window.document.documentElement.setAttribute("dir", this.IsShow() ? 'rtl' : 'ltr');
    window.document.documentElement.setAttribute(
            'dir',
            this.IsShow() ? 'rtl' : 'ltr'
        )
    this.getNotice()
    this.getBanner()
    this.getList()
    this.getDomains()
    this.getVersionsApi()
    this.horseLamp()
  },
  methods: {
    horseLamp() {
      getActivityLoop().then((res) => {
        this.joinUserList = this.filterData(res.data.noticeAwardList)
      })
    },
    filterData(val) {
      let data = []
      val.forEach((item) => {
        if (item.notice) {
          data.push({
            type: 1,
            notice: item.notice,
          })
        }
        if (item.eventAwards) {
          data.push({
            type: 2,
            ...item.eventAwards,
          })
        }
      })
      return data
    },
    IsShow(){
        return getCookie('language') == 'fa'?true:false
    },
    change_language(){
        let paramsName = this.$route.query.language
        const language = getCookie('language')||'en'
        if(paramsName!=language){
            if(languageArr.indexOf(paramsName)!==-1){
                setCookie('language',paramsName)
                this.$store.dispatch('setLanguageName',languageName[paramsName])
                setCookie('languageName', languageName[paramsName])
                document.documentElement.setAttribute('lang', paramsName)
                setTimeout(() => {
                    this.$i18n.locale = paramsName
                }, 500)
                this.$router.replace(`/index?language=${paramsName}`)
            }else{
                this.$router.replace(`/index?language=${language}`)
            }
        }
    },
    goUrl(item) {
      if (item.linkType == 1){ return false; }
      else if (item.linkType == 3 || item.linkType == 5) { this.$router.push(item.link); }
       else { window.open(item.link); }
    },
    // 千分符
    toThousands(num) {
      return toThousands(num);
    },
    getNotice() {
      getNotice({ pageSize: 3 }).then(res => {
        if (res.code == "200") {
          this.noticeList = res.data;
        }
      });
    },
    handleLink(url) {
      window.location.href = url
    },
    getBanner() {
      getBanner({ type: 3 }).then(res => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      }).catch(() => {
      });
    },
    getList() {
      getList().then(res => {
        if (res.code == "200") {
          this.articleList = res.data;
          this.articleList.forEach((v, i) => {
            v.sort = i;
            this.titleList.push(v.title);
          });
        }
      });
    },
    goLink(url) {
      if (!url) {
        return false
      } else {
        window.open(url)
      }
    },
    qrcode() {
      var _this = this;
      let qrcode = new QRcode("qrcode", {
        width: 112,
        height: 112, // 高度
        text: _this.domain + "/download", // 二维码内容
        correctLevel: QRcode.CorrectLevel.L
      });
      qrcode._el.title = ""; //清除标题，不然鼠标停留在二维码上面会暴露二维码内容
    },
    getDomains() {
      getDomains().then(res => {
        this.domain = res.data;
        this.qrcode();
      });
    },
    // 获取下载版本信息
    getVersionsApi() {
      versionsApi().then(res => {
        // this.downloadUrl.appStore = 'https://testflight.apple.com/join/nPtPpKJr'
        this.downloadUrl.TFLink = res.data.find(v => v.client == "2")
          ? res.data.find(v => v.client == "2").extraLink
          : "";
        this.downloadUrl.appStore = res.data.find(v => v.client == "2")
          ? res.data.find(v => v.client == "2").link
          : "";
        this.downloadUrl.googlePlay = res.data.find(v => v.client == "3")
          ? res.data.find(v => v.client == "3").link
          : "";
        this.downloadUrl.androidApk = res.data.find(v => v.client == "3")
          ? res.data.find(v => v.client == "3").extraLink
          : "";
      });
    },
    initWebSocket(wsurl) {
      if ("WebSocket" in window) {
        this.websocke = new WebSocket(wsurl);
      } else if ("MozWebSocket" in window) {
        this.websocke = new MozWebSocket(wsurl);
      } else {
        console.log("Your browser does not support websocket.");
        return false;
      }
      this.websocke.onopen = this.websocketonopen;
      this.websocke.onerror = this.websocketonerror;
      this.websocke.onmessage = this.websocketonmessage;
      this.websocke.onclose = this.websocketclose;
    },
    websocketonopen() {
      console.log("WebSocket连接成功", parseTime(+new Date().getTime()));
      this.heart();
      var channel = {
        op: "sub",
        args: [
          "exchange_rate:spot",
          "spot/config:spot",
          "spot/home:spot",
        ]
      };
      this.websocketsend(channel);
    },
    websocketonerror(e) {
      //错误
      console.log("WebSocket连接发生错误");
    },
    websocketsend(agentData) {
      //数据发送
      this.websocke.send(JSON.stringify(agentData));
    },
    websocketclose(e) {
      //关闭
      // console.log("connection closed (" + e.code + ")");
      console.log("WebSocket断开连接", parseTime(+new Date().getTime()));
      if (!this.socketStatus) {
        return false;
      }
      this.pongTime = null;
      this.heartCheck.reset();
      setTimeout(() => {
        this.initWebSocket(configs[configs.Edition].socketUrl);
      }, 5000);
    },
    heart() {
      var _this = this;
      this.heartCheck = {
        timeout: 5000,
        timeoutObj: null,
        timeoutObjTwo: null,
        reset: function () {
          clearTimeout(this.timeoutObj);
          clearTimeout(this.timeoutObjTwo);
          this.start();
        },
        start: function () {
          this.timeoutObj = setTimeout(() => {
            _this.websocke.send("ping");
          }, this.timeout);

          this.timeoutObjTwo = setTimeout(() => {
            if (
              _this.pongTime &&
              new Date().getTime() - _this.pongTime > 8000
            ) {
              _this.websocke.close();
            }
          }, 10000);
        },
        clear: function () {
          clearTimeout(this.timeoutObj);
        }
      };
      this.heartCheck.start();
    },
    websocketonmessage(e) {
      //数据接收
      //注意：长连接我们是后台直接1秒推送一条数据，
      //但是点击某个列表时，会发送给后台一个标识，后台根据此标识返回相对应的数据，
      //这个时候数据就只能从一个出口出，所以让后台加了一个键，例如键为1时，是每隔1秒推送的数据，为2时是发送标识后再推送的数据，以作区分
      if (e.data == "pong") {
        this.pongTime = new Date().getTime();
        this.heartCheck.reset();
        return false;
      }
      var res = JSON.parse(this.decode(e.data));
      // console.log(res)
      var _this = this;
      if (res.table == "spot/config" && res.data) {
        _this.listLoading = false;
        res.data.forEach(v => {
          v.priceTick = toNonExponential(v.priceTick);
          v.sizeTick = toNonExponential(v.sizeTick);
        });
        for (let i in res.data) {
          _this.marketConfig[res.data[i]["symbol"]] = res.data[i];
        }
        localStorage.setItem(
          "marketConfig",
          JSON.stringify(_this.marketConfig)
        );
        this.$store.dispatch(
          "setCurrentMarketConfig",
          _this.marketConfig["btc_usdt"]
        );
        localStorage.setItem(
          "currentMarketConfig",
          JSON.stringify(_this.marketConfig["btc_usdt"])
        );
      } else if (res.table == "exchange_rate" && res.data) {
        // console.log(res.data, 'exchange_rate')
        for (let i in res.data) {
          _this.rateConfig[res.data[i]["currency"]] = res.data[i];
        }
        localStorage.setItem("rateConfig", JSON.stringify(_this.rateConfig));
      } else if (res.table == "spot/home" && res.data) {
        res.data.forEach(v => {
          v.recentQuotation = toNonExponential(v.recentQuotation)
          v.state = _this.marketConfig[v.symbol]
            ? _this.marketConfig[v.symbol].state
            : "3";
        });
        _this.marketList = res.data;
      }
    },
    decode(encodedData) {
      var decodedData = window.atob(encodedData);
      var charData = decodedData.split("").map(function (x) {
        return x.charCodeAt(0);
      });
      var binData = new Uint8Array(charData);
      var data = pako.inflate(binData);
      var myArr = new Uint16Array(data);
      var num = 1000,
        strings = "";
      var uintArray = new Uint16Array(data);
      var converted = [];
      uintArray.forEach(function (byte) {
        converted.push(String.fromCharCode(byte));
      });
      return converted.join("");
    },
  },
  mounted() {
    if (configs[configs.Edition].socketUrl.length > 0) {
      this.initWebSocket(configs[configs.Edition].socketUrl);
    }
  },
  destroyed() {
    this.socketStatus = false;
    clearInterval(this.heartCheck.timeoutObj);
    clearInterval(this.heartCheck.timeoutObjTwo);
    this.pongTime = null;
    this.websocke.close();
  }
}
</script>
<style lang="scss">
@import "../style/mixin";
@import "../assets/css/variableName";
[dir="ltr"] .index-page {
  .download-content {
    margin-left: torem(8);
    margin-right: torem(16);
  }
  .download-close-icon {
    margin-left: torem(12);
  }
  .left-icon {
    svg.icon {
      margin-right: torem(4);
    }
  }
  .td {
    img {
      margin-right: torem(8);
    }
  }
  .title-content {
    padding-left: torem(8);
    border-left: torem(4) solid #ffc72b;
  }
  .global-trade .items img {
    margin-right: torem(12);
  }
 .activity-left{
    .van-swipe-item{
      img{
        margin-right: torem(4);
      }
    }
  }
}
[dir="rtl"] .index-page {
 .activity-left{
    .van-swipe-item{
      img{
        margin-left: torem(4)!important;
      }
    }
  }
  .download-content {
    margin-right: torem(8);
    margin-left: torem(16);
  }
  .download-close-icon {
    margin-right: torem(12);
  }
  .left-icon {
    svg.icon {
      margin-left: torem(4);
    }
  }
  .td {
    img {
      margin-left: torem(8);
    }
  }
  .title-content {
    padding-right: torem(8);
    border-right: torem(4) solid #ffc72b;
  }
  .global-trade .items img {
    margin-left: torem(12);
  }
}
</style>
<style lang="scss" scoped>
@import "../style/mixin";
@import "../assets/css/variableName";

.index-page {
  position: relative;
  .header-top {
    position: relative;
  }

  .app-down {
    padding: torem(10) torem(24);
    background-color: #fff6dc;
   dl{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

          dt{
            svg{
              width: torem(24);
              height: torem(24);
            }
          }
          dd{
            width: torem(48);
            text-align: center;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-top: torem(4);
            font-size: torem(10);
            line-height: torem(12);
          }

      }

    .download-content {
      p {
        font-size: torem(15);
        color: #40475a;
        margin-bottom: torem(4);
        font-weight: bold;
      }

      span.block {
        font-size: torem(10);
        color: #40475a;
        line-height: torem(11);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }

    .download-icon {
      width: torem(36);
      height: torem(36);
      line-height: torem(36);
      text-align: center;
      border-radius: 50%;
      background-color: #ffc72b;
      font-weight: bold;
    }

    .icon-guanbi1 {
      font-size: torem(14);
      color: #7f8490;
    }
  }

  .index-main {
    width: 100%;
    height: auto;
    //background: #FFFFFF;
    /deep/ .van-notice-bar {
      height: torem(36);
      line-height: torem(36);
      font-size: torem(13);
      color: #000922;
      background: transparent;
      padding: torem(0) torem(16);

      .left-icon {
        svg.icon {
          width: torem(20);
          height: torem(20);
          margin-top: torem(12);
        }
      }
      .right-icon {
        a {
          font-size: torem(12);
          color: #ffc72b;
        }
      }

      .van-swipe-item {
        width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .banner-container {
      padding: torem(0) torem(16);
      margin-bottom: torem(16);

      img {
        width: torem(343);
        height: torem(144);
        border-radius: torem(6);
      }
    }

    .market-table {
      padding: torem(0) torem(16);

      .thead {
        padding: torem(0) torem(12);
        background-color: rgba(255, 199, 43, 0.1);

        .th {
          width: 33%;
          padding: torem(16) 0;
          font-size: torem(12);
          color: #7f8490;
          &:last-child {
            text-align: end;
          }
        }
      }
      .tr {
        padding: torem(0) torem(12);
        .td {
          width: 33%;
          padding: torem(15) 0;
          font-size: torem(14);
          color: #000922;
          font-weight: bold;
          img {
            width: torem(25);
            height: torem(25);
          }
          .englishName {
            font-size: torem(12);
            color: #7f8490;
            font-weight: normal;
            margin-top: torem(3);
          }
          svg {
            width: torem(10);
            height: torem(14);
          }
        }
        .td.right {
          justify-content: flex-end;
        }
      }
      .more {
        margin-top: torem(12);
        font-size: torem(12);
        color: #40475a;
        text-align: center;
        i {
          font-size: torem(12);
        }
      }
    }
    .title-content {
      margin: 0 0 torem(12);
      color: #000922;
      font-size: torem(18);
    }
    .novice-guidance {
      padding: 0 torem(16);
      margin: 0 0 torem(63);
      p {
        color: #40475a;
        font-size: torem(12);
        line-height: torem(18);
        margin-bottom: torem(16);
      }
      .novice-guidance-content {
        overflow-x: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        .first-title {
          padding: torem(7) torem(16);
          font-size: torem(14);
          color: #333333;
          font-weight: bold;
          margin-bottom: torem(16);
        }
        .first-title.active {
          background-color: #eaecef;
          border-radius: torem(4);
        }
        .article-item {
          margin-right: torem(12);
          a {
            width: torem(286);
            height: torem(145);
            border-radius: torem(16);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            margin-bottom: torem(16);
          }
          .second-title {
            font-size: torem(14);
            color: #000922;
            line-height: torem(16);
          }
        }
      }
    }
    .global-trade {
      padding: 0 torem(16);
      margin-bottom: torem(64);
      p {
        color: #40475a;
        font-size: torem(12);
        line-height: torem(18);
      }
      .items {
        margin-top: torem(44);
        align-items: flex-start;
        img {
          width: torem(64);
          height: torem(64);
        }
        .item-content {
          p {
            color: #000922;
            font-size: torem(16);
            font-weight: bold;
            margin-bottom: torem(12);
          }
          span.block {
            color: #40475a;
            font-size: torem(12);
            line-height: torem(18);
          }
        }
      }
    }
    .download-app {
      padding: 0 torem(16) torem(28) torem(16);
      p {
        color: #40475a;
        font-size: torem(12);
        line-height: torem(18);
      }
      img {
        width: torem(343);
        height: torem(242);
        margin: torem(24) 0;
      }
      .qrcode-box {
        width: torem(146);
        height: torem(192);
        padding: torem(16) torem(17) 0;
        border-radius: torem(4);
        box-shadow: 0 torem(2) torem(4) 0 rgba(0, 0, 0, 0.08);
        text-align: center;
        #qrcode {
          border-radius: torem(4);
        }
        p {
          margin-top: torem(7);
          line-height: torem(14);
          font-size: torem(12);
          color: #000922;
        }
      }
      .link-box {
        width: torem(177);
        div.flex-between {
          div.flex {
            width: torem(80);
            height: torem(78);
            margin-bottom: torem(16);
            flex-direction: column;
            align-items: center;
            justify-content: center;
            i {
              font-size: torem(24);
              margin-bottom: torem(8);
              color: #333;
            }
            span {
              font-size: torem(12);
              color: #000922;
            }
          }
        }
      }
      .more {
        margin-top: torem(28);
        font-size: torem(12);
        color: #40475a;
        text-align: center;
        i {
          font-size: torem(12);
        }
      }
    }
    .register-box {
      padding: torem(24) torem(16);
      background-color: #f5f5f7;
      text-align: center;
      h1 {
        font-size: torem(16);
        font-weight: bold;
        color: #000922;
        line-height: torem(24);
        margin: 0 0 torem(24);
      }
      span.inline-block {
        padding: torem(11) torem(48);
        border-radius: torem(4);
        background-color: #ffc72b;
        font-weight: bold;
        color: #000922;
        font-size: torem(16);
        line-height: torem(18);
      }
    }
    .notice-swipe {
      height: torem(36);
      line-height: torem(36);
    }
  }
}
.activity-center{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: torem(343);
  margin: torem(16) auto;
  background: rgba(249, 250, 252, 1);
  border-radius: torem(8);
  padding: torem(17) torem(12) torem(15);
}
.activity-left{
  .activity-title {
    display: flex;
    align-items: center;
    height: auto;
    span{
      &:first-child{
        color: rgba(0, 0, 0, 0.90);
        font-size: torem(16);
      }
      &:last-child{
        display: inline-block;
        color:rgba(255, 255, 255, 0.85);
        font-size: torem(12);
        background: rgba(245, 67, 70, 1);
        border-radius: torem(16);
        line-height: torem(12);
        padding: torem(2) torem(6);
        margin: 0 torem(5);
      }
    }
  }

  .van-swipe-item{
    flex-shrink: 0;
    img {
      width: torem(16);
      height: torem(16);
    }
    p {
      display: flex;
      //align-items: center;
      //text-align: start;
      line-height: torem(32);
      font-size: torem(12);
      color: rgba(0, 0, 0, 0.60);
      //height: torem(18);
      height: auto;
      //line-height: torem(32);
      flex-shrink: 0;
    }
  }
}
.activity-right{
  img{
    width: torem(64);
    height: torem(64);
    object-fit: cover;
  }
}
/deep/ .activity-notice{
  margin-top: torem(10);
  height: torem(36)!important;
  width: torem(219);
  .van-swipe-item{
    display: flex;
    align-items: flex-start;
    height: torem(36);
    line-height: torem(18);
    p{
      //display: inline-block;
      font-size: torem(12);
      flex: 1;
      line-height: torem(18);
      text-overflow: -o-ellipsis-lastline;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue